import React from 'react';
import logo from './logo.svg';
import { Route, Routes } from 'react-router-dom';
import './App.css';
import { Redirect } from './redirect';
import StaticClientForm from './staticclientform';
import ShowReserve from './showreserve';
import { NewClientForm } from './newclientform';
import PersonalInfo from './personalinfo';

function App() {
  return (
    <Routes>
            <Route path="/" element={<Redirect path='/main'/>} />
            <Route path="/bookingform" element={<StaticClientForm />} />
            <Route path="/showreserve" element={<ShowReserve />} />
            <Route path="/newform" element={<NewClientForm />} />
    </Routes>
  );
}

export default App;
